module.exports = __webpack_public_path__ + "static/media/shop.983b808e.svg";